import {Component, AfterViewInit, Output, EventEmitter} from '@angular/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';
import {PermisoPantalla} from '@modelo/PermisoPantalla.model';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

@Component(
    {
        selector: 'pathPantalla',
        templateUrl: './PathPantalla.template.html',
    })

export class PathPantallaComponent implements AfterViewInit {
    @Output() permisosLoaded = new EventEmitter();
    
    constructor(private appService: AppService, public sistemaService: SistemaService) {
        this.sistemaService.permisos = new PermisoPantalla();
    }

    ngAfterViewInit() {
        this.permisos();
    }

    permisos() {
        this.appService.Get("inicio/permisos/pantalla/" + this.sistemaService.pantallaid).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.sistemaService.permisos = res.data;
                this.permisosLoaded.next(true);
            }
        });
    }
}
